export enum MediaQueries {
    XLARGE = "@media (max-width: 1290px)",
    LARGE = "@media (max-width: 1050px)",
    MEDIUM = "@media (max-width: 860px)",
    SMALL = "@media (max-width: 650px)",
    XSMALL = "@media (max-width: 500px)",
}
